module.exports = new __parcel__URL__("slices.7de43cc9.svg").toString();